














import { Component, Inject, Vue } from "vue-property-decorator";

@Component({})
export default class TvCommandButtons extends Vue {
  @Inject({ from: "commands", default: null }) readonly commands!: string;

  updateTime = "now";
  key = "";
  value = "";
}
